import React from 'react'
import PropTypes from 'prop-types';
import _ from "underscore";

const WidgetValues = function (props) {
    const WidgetBlocks = props.blocks;
    let blocks = [];
    let sorted = Object.keys(WidgetBlocks).sort();
    for(let i in sorted){
        let widgetType = sorted[i];
        let Component = WidgetBlocks[widgetType].component;
        let childComponents = WidgetBlocks[widgetType].childComponents;
        if (Component) blocks.push(<Component key={i} {...props} childComponents={childComponents}/>);
    }

    const pageWidgets = [props.context.pages.map(x => x.widgets)];
    if (!!props.context.sliderChildren) {
        pageWidgets.push(props.context.sliderChildren.map(child => child.widgets));
    }
    let appHasWidgets = _.flatten(pageWidgets).filter(x => {
        return WidgetBlocks[x.type] && WidgetBlocks[x.type].component;
    }).length > 0;

    // Hamburger menus are sent separately from page and slider widgets.
    // Keep Widget Values visible for hamburger menus, even when the app has no other widgets.
    const appHasHamburgers = props.context.hamburgers?.length > 0 && // The app has hamburger menus.
        Object.keys(WidgetBlocks.hamburger?.childComponents || {}).length > 0; // At least one hamburger block remains after app-type filtering.

    // Do not render the category when neither widget blocks nor hamburger blocks are available.
    if(!appHasWidgets && !appHasHamburgers){
        return null;
    }

    return (
        <category name='Widget Values' id='widgetValues' iconclass='category with-icon-paths snap-icon-widget_value_dual'>
            {blocks}
        </category>
    )
};

WidgetValues.propTypes = {
    context: PropTypes.object.isRequired,
    blocks: PropTypes.object.isRequired
};

export default WidgetValues;
